var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column page-content text-left h-100 w-75 mx-auto"},[_c('h2',{staticClass:"text-lg text-center text-gray-dark"},[_vm._v(" "+_vm._s(_vm.$t("messages.app.ui.session_timer_expired_title"))+" ")]),_c('p',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.$t('messages.app.ui.session_timer_expired', {
      duration: _vm.formattedSessionMaximalDuration,
    }))}}),_c('p',{staticClass:"h1 text-center"},[_vm._v(_vm._s(_vm.waitSeconds))])])
}
var staticRenderFns = []

export { render, staticRenderFns }